import { combineReducers } from '@reduxjs/toolkit';

import api from '../api/api';

// reducers
// GENERAL
import dictionariesReducer from './dictionaries/slice';
import problemGeneralTransactionReducer from '../hoc/common/store/slices/problem-transactions/gl-transaction';
import problemInternalTransactionReducer from '../hoc/common/store/slices/problem-transactions/internal-transaction';
import problemIncomingTransactionReducer from '../hoc/common/store/slices/problem-transactions/incoming-transaction';
import problemOutgoingTransactionReducer from '../hoc/common/store/slices/problem-transactions/outgoing-transaction';
import problemExchangeTransactionReducer from '../hoc/common/store/slices/problem-transactions/exchange-transaction';
import problemNostroTransactionReducer from '../hoc/common/store/slices/problem-transactions/nostro-transaction';
import customerStatementsReducer from '../hoc/common/store/slices/statements';
import customerCardsReducer from '../hoc/common/store/slices/cards';
import customerDocumentsReducer from '../hoc/common/store/slices/documents/documents';
import customerDocumentCreateReducer from '../hoc/common/store/slices/documents/create';
import customerTariffsReducer from '../hoc/common/store/slices/tariff/tariff';
import customerFeeFormReducer from '../hoc/common/store/slices/tariff/form';
import customerTransactionFromFeeReducer from '../hoc/common/store/slices/tariff/transaction-from-fee';
import customersGeneralTransactionReducer from '../hoc/common/store/slices/statement-gl-transaction';
import customerTopUpPanelReducer from '../hoc/common/store/slices/top-up-panel';
import customerBeneficiariesReducer from '../hoc/common/store/slices/beneficiaries';
import customersExternalAccountsReducer from '../hoc/common/store/slices/external-integration';
import customersNotificationsCetner from '../hoc/notification-center/store/slices';
import customerAccountsReducer from '../hoc/common/store/slices/accounts';
import customerAmlReducer from '../hoc/common/store/slices/aml';
import customerStatisticReducer from '../hoc/common/store/slices/statistics';

// INDIVIDUAL
import individualCustomersListReducer from '../hoc/individual/store/slices/list';
import individualCustomerGeneralInfoReducer from '../hoc/individual/store/slices/general-info';
import individualCustomerOverviewReducer from '../hoc/individual/store/slices/overview';
import individualCustomerDevicesReducer from '../hoc/individual/store/slices/devices';
import individualCustomerSecurityReducer from '../hoc/individual/store/slices/security';

// CORPORATE
import corporateCustomersListReducer from '../hoc/corporate/store/slices/list';
import corporateCustomerGeneralInfoReducer from '../hoc/corporate/store/slices/general-info';
import corporateCustomerOverviewReducer from '../hoc/corporate/store/slices/overview';

// NEW APPLICATION
import newApplicationListReducer from '../hoc/new-application/store/slices';
import newApplicationIndividualInfoReducer from '../hoc/new-application/individual/store/slices';
import newApplicationCorporateInfoReducer from '../hoc/new-application/corporate/store/slices';
import newApplicationMainRepresentativeReducer from '../hoc/new-application/main-representative/store/slices';

// middlewares
import customerMiddleware from '../hoc/customers/store/middlewares/customers';

export const customersReducers = {
  customersApi: api.reducer,
  customersDictionaries: dictionariesReducer,
  customersNotificationsCenter: customersNotificationsCetner,
  customersProblemTransactions: combineReducers({
    gl: problemGeneralTransactionReducer,
    internal: problemInternalTransactionReducer,
    incoming: problemIncomingTransactionReducer,
    outgoing: problemOutgoingTransactionReducer,
    exchange: problemExchangeTransactionReducer,
    nostro: problemNostroTransactionReducer,
  }),
  statistic: customerStatisticReducer,
  customersStatmenetsTransactions: combineReducers({
    gl: customersGeneralTransactionReducer,
  }),
  customerBeneficiaries: customerBeneficiariesReducer,
  customerStatements: customerStatementsReducer,
  customerCards: customerCardsReducer,
  customerDocuments: customerDocumentsReducer,
  customerDocumentCreate: customerDocumentCreateReducer,
  customerTariffs: customerTariffsReducer,
  customerFeeForm: customerFeeFormReducer,
  customerTransactionFromFee: customerTransactionFromFeeReducer,
  customersExternalAccounts: customersExternalAccountsReducer,
  customersAccounts: customerAccountsReducer,
  topUpPanel: customerTopUpPanelReducer,
  customerAml: customerAmlReducer,
  individualCustomers: combineReducers({
    list: individualCustomersListReducer,
    info: combineReducers({
      general: individualCustomerGeneralInfoReducer,
      overview: individualCustomerOverviewReducer,
      devices: individualCustomerDevicesReducer,
      security: individualCustomerSecurityReducer,
    }),
  }),
  corporateCustomers: combineReducers({
    list: corporateCustomersListReducer,
    info: combineReducers({
      general: corporateCustomerGeneralInfoReducer,
      overview: corporateCustomerOverviewReducer,
    }),
  }),
  newApplications: combineReducers({
    individualInfo: newApplicationIndividualInfoReducer,
    corporateInfo: newApplicationCorporateInfoReducer,
    mainRepresentative: newApplicationMainRepresentativeReducer,
    list: newApplicationListReducer,
  }),
};

export const customersApi = [api.middleware, customerMiddleware.middleware];
